import React, { useState } from 'react';
import {
    Paper, Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, TablePagination, InputAdornment, TableSortLabel
} from '@mui/material';
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SearchIcon from '@mui/icons-material/Search';
import SoftTypography from 'components/SoftTypography';
import { useSelector } from 'react-redux';
import { is } from 'immutable';
import { useAuth } from '../../../../AuthContext';
export default function CommonDataTable({
    title,
    isDone = true,
    columns,
    rows,
    onRequestSort,
    search,
    setSearch,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    totalPages,
    isApiLoading,
    isSorting = false
}) {
    //    const { isApiLoading  } = useAuth();
    const debounceRef = React.useRef(null);
    const userTheme = useSelector((state) => state.commonSlice.theme);
    const [orderBy, setOrderBy] = useState('');
    const [order, setOrder] = useState('desc');
    const [columnsState, setColumnsState] = useState(columns);

    const handleSearch = (e) => {
        const value = e.target.value;

        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(() => {
            setSearch(value);
            setRowsPerPage(10)
            setPage(1);
        }, 500); // 500ms debounce
    };
    const handleChangePage = (_, newPage) => {

        setPage(newPage + 1);
    };

    const handleChangeRowsPerPage = (e) => {
        setPage(1);
        setRowsPerPage(+e.target.value);
    };



    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : orderBy ? 'asc' : 'desc';

        setOrder(newOrder);
        setOrderBy(property);

        // You get both direction and id here
        if (onRequestSort) {
            onRequestSort(property, newOrder);
        }
    };

    const createSortHandler = (property) => (event) => {
        handleRequestSort(event, property);
    };

    return (
        <>
            <SoftBox>
                <SoftBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    flexWrap="wrap"
                    gap={2}
                >
                    {/* Entries Dropdown */}
                    <SoftBox display="flex" alignItems="center" gap={1}>
                        <SoftBox className="dataTables_length" id="user-table_length" style={{ marginTop: '20px', marginBottom: '20px' }}>
                            <SoftTypography variant="h6" fontWeight="bold" color="text">
                                Show
                                <select
                                    name="user-table_length"
                                    onChange={handleChangeRowsPerPage}
                                    value={rowsPerPage}
                                    aria-controls="user-table"
                                    style={{
                                        border: '1px solid #aaa',
                                        borderRadius: '3px',
                                        backgroundColor: '#000',
                                        color: '#fff',
                                        padding: '4px',
                                        marginLeft: '7px',
                                        marginRight: '7px'
                                    }}
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                                entries
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>

                    {/* Search Field */}
                    <SoftInput
                        placeholder="Search here...."
                        variant="outlined"
                        onChange={handleSearch}
                        // value={search}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon sx={{ color: '#e600c0', height: '20px' }} />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            width: '20% !important',
                            borderRadius: '5px',
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '999px',
                                '& input': {
                                    WebkitTextFillColor: '#000',
                                },
                            },
                        }}
                    />
                </SoftBox>
            </SoftBox>

            {/* Table */}
            <TableContainer sx={{ boxShadow: 'none', minHeight: "auto", maxHeight: "100%", borderRadius: '0px', background: 'transparent !important' }}>
                <Table sx={{ background: 'transparent !important', boxShadow: 'none' }}>
                    <TableHead sx={{ display: 'table-header-group', background: 'transparent !important' }}>
                        <TableRow>
                            {columns?.map((col, ind) => (
                                <TableCell
                                    key={col.id}
                                    align={col.align || 'left'}
                                    sortDirection={orderBy === col.id ? order : false}
                                    sx={{
                                        border: ".2px solid rgb(189, 189, 189)",
                                        color: userTheme === 'dark' ? '#fff' : '#000',
                                    }}
                                >
                                    <TableSortLabel
                                        sx={{
                                            color: userTheme === 'dark' ? '#fff' : '#000',
                                            whiteSpace: 'nowrap'
                                        }}
                                        hideSortIcon={!col.isSorting}
                                        active={orderBy === col.id}
                                        direction={columnsState[ind].sortDirection}
                                        // onClick={createSortHandler(col.id)}
                                        onClick={() => {
                                            const updatedColumns = [...columnsState];
                                            const newDirection = updatedColumns[ind].sortDirection === 'asc' ? 'desc' : 'asc';

                                            // 👇 Create a new copy of columns to update state
                                            updatedColumns[ind] = {
                                                ...updatedColumns[ind],
                                                sortDirection: newDirection,
                                            };
                                            setColumnsState(updatedColumns); // ✅ Triggers re-render

                                            setOrder(newDirection);
                                            setOrderBy(col.id);

                                            if (onRequestSort) {
                                                onRequestSort(col.id, newDirection); // 👈 Pass id & direction to parent
                                            }
                                        }}
                                    >
                                        {col.label}
                                    </TableSortLabel>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(rows?.length > 0) ? (
                            rows.map((row, i) => (
                                <TableRow key={i} sx={{
                                    backgroundColor: i % 2 === 0 ? (userTheme === "dark" ? "#1e1e1e" : "#f9f9f9") : "inherit", // striped rows
                                    '&:hover': {
                                        backgroundColor: userTheme === "dark" ? "#2a2a2a" : "#f1f1f1", // hover effect
                                    },
                                }}>
                                    {columns.map((col) => (
                                        <TableCell key={col.id} align={col.align || 'left'} sx={{
                                            border: ".2px solid rgb(189, 189, 189)",
                                            color: userTheme == 'dark' ? '#fff' : '#000',
                                            padding: "10px 16px",
                                            whiteSpace: 'nowrap',
                                            '& *': {
                                                color: userTheme == 'dark' ? '#fff' : '#000', // apply to all children
                                            },
                                        }}>
                                            {col.render ? col.render(row, i) : row[col.id]}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                {(isDone) &&
                                    <TableCell colSpan={columns.length} align="center" sx={{
                                        border: ".2px solid rgb(189, 189, 189)",
                                        color: userTheme == 'dark' ? '#fff' : '#000',
                                        padding: "12px 16px",
                                    }}>
                                     {isApiLoading ? "Fetching your data..." : "Oops! No data found."}

                                    </TableCell>}
                            </TableRow>
                        )}
                    </TableBody>

                </Table>
            </TableContainer>

            {/* Pagination and Count */}
            {rows && <SoftBox display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                <SoftTypography variant="h6" fontWeight="bold" color="text" >
                    Showing {page} to {rowsPerPage} of {totalPages} entries
                </SoftTypography>
                <TablePagination
                    component="div"
                    count={totalPages || 0}
                    page={page - 1}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage || 0}
                    rowsPerPageOptions={[]}
                    color="text"
                    sx={{
                        color: userTheme == 'dark' ? '#fff' : '#000', // Cell text color
                    }}
                />
            </SoftBox>}
        </>
    );
}
